import { object } from '@calendly/form/validation'

import { formatNameValue, getNameInitialValue, getNameValidationSchema } from 'components/event_type_edit'

import { filterEmptyValues } from '../../utils'

export const getInitialValues = (eventType) => ({
  ...getNameInitialValue(eventType),
  color: eventType.color
})

export const formatValuesToServerData = (values) => filterEmptyValues({
  ...formatNameValue(values),
  color: values.color
})

export const getValidationSchema = () => object({})
  .concat(getNameValidationSchema())
